import { ImageWithFocalPoint } from '@omnia/ui/src/lib'
import type { GridElement } from '@omnia/ui/src/lib/cms/grid/interfaces/gridElement'
import type { CmsImageWithFocalPoint } from '@omnia/ui/src/lib/cms/types/cmsImageWithFocalPoint'
import type { FC } from 'react'

export const Media: FC<GridElement<CmsImageWithFocalPoint>> = props => {
    return (
        <>
            <ImageWithFocalPoint
                {...props.value}
                dimensions={{
                    width: 760,
                    tablet: {
                        width: 1000,
                    },
                    desktop: {
                        width: 1200,
                    },
                }}
            />
            {/* {!!caption && <p>{caption}</p>} */}
        </>
    )
}
